import { render } from "./TranChannelMappingModal.vue?vue&type=template&id=e0f4c98a"
import script from "./TranChannelMappingModal.vue?vue&type=script&lang=js"
export * from "./TranChannelMappingModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__